import { flattenObject } from "./flatten";

export function preparePayload(
  payload: Record<string, any>,
  skipFiltering = false,
) {
  const filteredPayload = !skipFiltering
    ? removePropertiesWithZero(payload)
    : payload;

  payload.inferredTags = removePropertiesWithZero(payload.inferredTags);
  payload.inferredProducts = removePropertiesWithZero(payload.inferredProducts);

  delete payload?.inferredTags?.isCorrectImage;
  delete payload?.inferredTags?.isCorrectTitle;

  return { flattenedPayload: flattenObject(filteredPayload), filteredPayload };
}

function removePropertiesWithZero(
  payload: Record<string, any>,
  skipFlattening = false,
) {
  const filteredPayload = !skipFlattening
    ? squashFlattenedArrayObjects({ ...payload })
    : { ...payload };

  for (const key in filteredPayload) {
    const isZero =
      typeof filteredPayload[key] !== "object" && filteredPayload[key] === 0;

    const isEmptyObject =
      typeof filteredPayload[key] === "object" &&
      Object.keys(filteredPayload[key]).length === 0;

    if (isZero || isEmptyObject) {
      delete filteredPayload[key];
    } else if (typeof filteredPayload[key] === "object") {
      filteredPayload[key] = removePropertiesWithZero(
        filteredPayload[key],
        skipKeysForFlattening.includes(key),
      );
    }
  }

  for (const key in filteredPayload) {
    if (
      typeof filteredPayload[key] === "object" &&
      Object.keys(filteredPayload[key]).length === 0
    ) {
      delete filteredPayload[key];
    }

    if (typeof filteredPayload[key] === "object") {
      filteredPayload[key] = removePropertiesWithZero(
        filteredPayload[key],
        skipKeysForFlattening.includes(key),
      );
    }
  }

  return filteredPayload;
}

const skipKeysForFlattening = ["journey", "order"];

function squashFlattenedArrayObjects(payload: Record<string, any>) {
  const allKeysNumbers = Object.keys(payload).every((key) =>
    Number.isInteger(+key),
  );

  if (!allKeysNumbers) {
    return payload;
  }

  const squashedPayload: Record<string, any> = {};

  const values = Object.values(payload);

  for (const value of values) {
    for (const keys in value) {
      squashedPayload[keys] = Number.isInteger(value[keys])
        ? (squashedPayload[keys] || 0) + value[keys]
        : value[keys];
    }
  }

  return squashedPayload;
}
